export default {
  Title: 'Leads',
  ClientPage: 'See Active Clients',
  ClientStatus: 'Client status: ',
  Relationships: 'Relationships: ',
  Caregivers: 'Caregivers: ',
  Action: 'Create New Client',
  Filter: {
    Search: 'Search',
    SearchPlaceholder: 'Name or Contact',
    Status: 'Status',
  },
};
